<template>
    <el-row class="home_wrap" style="margin-left:0;margin-right:0;">
        <!-- 桥隧头部导航 -->
        <div class="home_top">
                <div class="home_top_name">隧道运行数字化监管平台</div>
                <div class="home_top_time">{{nowDate}}</div>
                <div class="home_top_nav">
                    <span @click="backSuidaoIndex"><i class="el-icon-s-home"></i>一网统管</span>
                    <span class="home_line"></span>
                    <span @click="qiaosuiManager"><i class="el-icon-coin"></i>桥隧管理</span>
                    <span class="home_line"></span>
                    <span><i class="iconfont icon-yonghu"></i>用户管理</span>
                </div>
        </div>
        <!-- 桥隧年 && 季度选择查询数据 -->
        <div class="home_select">
            <span @click="loginSelect" class="select_option select_option_color">年</span>
            <template>
                <el-select v-model="value" placeholder="请选择" v-bind:disabled="disabledSelect1" @change="selectVal">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </template>
            <span @click="loginSelect" class="select_option" style="padding:12px 6px;margin-left:30px;">季度</span>
            <template>
                <el-cascader v-bind:disabled="disabledSelect2" @change="selectVal"
                v-model="valuejidu"
                :options="jidu"
                :props="{ expandTrigger: 'hover' }">
                </el-cascader>
            </template>
        </div>
        <!-- 桥隧数据 && 条形图 && 雷达图 -->
        <div class="home_body">
            <div class="b01_div"></div>
            <div class="b02_div"></div>
            <div class="b03_div"></div>
            <div class="b04_div"></div>
            <div class="qiaosui_table_l">
                <table cellpadding='0' cellspacing='0' class="qiaosui_table">
                    <colgroup><col style="width: 27%" /><col style="width: 11%" /><col /></colgroup>
                    <thead><tr><th id="sort_name">由北到南地理排序</th><th>排名</th><th>桥隧名称</th></tr></thead>
                </table>
                <el-popover placement="bottom" width="200" trigger="click" content="">
                    <el-button value="1" class="sort_name" @click="geographySort('由北到南地理排序')">由北到南地理排序</el-button>
                    <el-button value="2" class="sort_name" @click="geographySort('由南到北地理排序')">由南到北地理排序</el-button>
                    <i slot="reference" class="el-icon-arrow-down sort_list"></i>
                </el-popover>
                <el-row>
                    <!-- 由北到南地理排序 -->
                    <el-col :span="6">
                        <div class="grid-content bg-purple dili_sort u_animation1">
                            <el-row style="margin-bottom:20px" v-for="item in suidaoList" :key="item.value">
                                <el-col :span="8" style="width:12%;">
                                    <div class="grid-content bg-purple">
                                        <div><img src="../../../assets/img/u945.png"></div>
                                        <div class="number_order">{{item.index}}</div>
                                    </div>
                                </el-col>
                                <el-col :span="16">
                                    <div class="grid-content bg-purple-light">
                                        <div class="dili_info dili_info_color b_blue" @click="enterSuidaoProject(item.TunnelId,item.number,item.name)">{{item.name}}</div>
                                        <div class="dili_info dili_style">{{item.number}}</div>
                                        <div class="dili_info">长度：{{item.length}}M</div>
                                        <div class="dili_info">正式通车时间：{{item.time}}</div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    <!-- 排名 && 桥隧名称 -->
                    <el-col :span="18">
                        <div class="grid-content bg-purple dili_sort u_animation1" style="font-size:16px;">
                            <el-row v-for="(item, index) in newsuidaoList" :key="item.value">
                                <el-col :span="2">
                                    <div class="grid-content bg-purple echarts_u01">{{item.index}}</div>
                                </el-col>
                                <el-col :span="22">
                                    <el-row>
                                        <el-col :span="5"><div class="grid-content bg-purple-light echarts_u02" @click="clickqiaosuiName(item.TunnelId, item.name)">{{item.name}}</div></el-col>
                                        <el-col :span="19"><div class="grid-content bg-purple-light echarts_u03"><div :id="'myChart' + index" style="width:100%;height: 25px;"></div></div></el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="qiaosui_table_r">
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple" style="text-align: right;margin-top: 10px;">
                            <span class="leida_title" @click="backLeida()"><i class="el-icon-back"></i>返回总体雷达图</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 10px;">
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <div class="grid-content bg-purple dili_sort u_animation1 leida_01" style="height:578px;padding:0;" id="leida_01">
                                <div v-for="(item, index) in suidaoList" :key="item.value">
                                    <div class="grid-content bg-purple dili_sort_body">
                                        <div :id="'myChart2' + index" style="width:296px;height:190px;"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="grid-content bg-purple dili_sort u_animation1 leida_01" style="height:578px;padding:0; display: none;" id="leida_02">
                                <div>
                                    <div class="grid-content bg-purple dili_sort_body">
                                        <div id="singleLeidaEcharts" style="width:600px;height:520px;"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 桥隧曲线展示 -->
        <div class="home_body" style="height:760px;overflow:visible;">
            <div class="b01_div" style="top:780px;"></div>
            <div class="b02_div" style="top:780px;"></div>
            <div class="b03_div" style="top:1513px;"></div>
            <div class="b04_div" style="top:1513px;"></div>
            <el-row>
                <el-col :span="24">
                    <div class="grid-content bg-purple-dark radio_select">
                        <el-radio v-model="radio" label="1" @change="radioVal" class="u_radio">技术评分</el-radio>
                        <el-radio v-model="radio" label="2" @change="radioVal" class="u_radio">通风设施</el-radio>
                        <el-radio v-model="radio" label="3" @change="radioVal" class="u_radio">照明设施</el-radio>
                        <el-radio v-model="radio" label="4" @change="radioVal" class="u_radio">给排水设施</el-radio>
                        <el-radio v-model="radio" label="5" @change="radioVal" class="u_radio">弱电设施</el-radio>
                        <el-radio v-model="radio" label="6" @change="radioVal" class="u_radio">供配电设施</el-radio>
                        <el-radio v-model="radio" label="7" @change="radioVal" class="u_radio">消防设施</el-radio>
                        <el-radio v-model="radio" label="8" @change="radioVal" class="u_radio">服务评分</el-radio>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <div class="grid-content bg-purple" style="padding:0 10px 10px 10px;text-align:left;margin-left:40px;">
                        <span style="color:#fff;font-size:14px;">请选择年：</span>
                        <el-date-picker v-model="indexYearVal" type="year" placeholder="选择年" value-format="yyyy" @change="getIndexYearVal"></el-date-picker>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <div class="grid-content bg-purple-dark u_animation2">
                        <div id="myChartLine" style="width:100%;height:630px;"></div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 点击隧道名称，显示折线图 -->
        <el-dialog
        :visible.sync="dialogVisible"
        width="70%">
        <div slot="title" class="header-title">{{dialogTitle}} - 设施完好率</div>
        <el-row>
            <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                    <el-radio v-model="dialogRadio" label="1" @change="dialogRadioVal">技术评分</el-radio>
                    <el-radio v-model="dialogRadio" label="2" @change="dialogRadioVal">通风设施</el-radio>
                    <el-radio v-model="dialogRadio" label="3" @change="dialogRadioVal">照明设施</el-radio>
                    <el-radio v-model="dialogRadio" label="4" @change="dialogRadioVal">给排水设施</el-radio>
                    <el-radio v-model="dialogRadio" label="5" @change="dialogRadioVal">弱电设施</el-radio>
                    <el-radio v-model="dialogRadio" label="6" @change="dialogRadioVal">供配电设施</el-radio>
                    <el-radio v-model="dialogRadio" label="7" @change="dialogRadioVal">消防设施</el-radio>
                    <el-radio v-model="dialogRadio" label="8" @change="dialogRadioVal">服务评分</el-radio>
                </div>
            </el-col>
        </el-row>
        <div id="dialogChart" style="width:100%;height:500px;"></div>
        </el-dialog>
    </el-row>
</template>

<script>
import $ from 'jquery'
import axios from "axios"
import * as echarts from 'echarts'
export default {
    name: 'bridgeTunnelIndex',
    data() {
        return {
            nowDate: '',
            // 选择年份
            options: [],
            value: `2019年`,
            jidu: [{
                value: '2019 季度',
                label: '2019年',
                children: [{
                    value: '01 04',
                    label: '1季度'
                    }, {
                    value: '04 07',
                    label: '2季度'
                    }, {
                    value: '07 10',
                    label: '3季度'
                    }, {
                    value: '10 12',
                    label: '4季度'
                }]
            }],
            valuejidu: '',
            disabledSelect1: false,
            disabledSelect2: true,
            projectList: [],
            suidaoList: [],
            radio: '1',
            suidaocity:'',
            suidaozhouqi: [],
            suidaowendu: [],
            suidaotianqi: [],
            newsuidaoList: [],
            yearSelectData: [],
            indexYearVal: '2019',
            valTitle: '',
            indexSpiralData: [],
            dialogVisible: false,
            dialogTitle: '',
            dialogTunnelId: 3,
            dialogRadio: '1'
        };
    },
    computed: {
        username() {
            let username = localStorage.getItem('ms_username');
            return username ? username : this.name;
        }
    },
    created(){
        let self = this
        const newDate = this.getLocalNewDate().split('/')[0] - 2
        // 添加年份数据
        for (let i = 0; i < 6; i++) {
            self.options.push({
                value: `${newDate - i}年`
            })
        }
        // 初始化加载方法
        self.selectVal(`${newDate}年`)
        self.radioVal('1')
        // 获取当前天气
        //axios.get("http://wthrcdn.etouch.cn/weather_mini?city=上海")
        //    .then(function(response) {
        //        let ele = response.data.data.forecast[0]
        //        self.suidaocity = response.data.data.city
        //        self.suidaozhouqi = ele.date.split('日')[1],
        //        self.suidaowendu = `${ele.high.split(' ')[1].split('℃')[0]}/${ele.low.split(' ')[1]}`,
        //        self.suidaotianqi =  ele.type
        //    })
    },
    mounted: function () {
        this.currentTime()
    },
    methods: {
        // 获取当前时间 && 实时刷新
        currentTime() {
            this.getCurrentTime()
            setInterval(this.getCurrentTime, 500)
        },
        getCurrentTime() {
            var _this = this
            let yy = new Date().getFullYear()
            let mm = new Date().getMonth()+1
            let dd = new Date().getDate()
            let hh = new Date().getHours()
            let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes()
            let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds()
            _this.gettime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss
            _this.nowDate = _this.gettime
            localStorage.setItem('newDate', _this.nowDate)
            return _this.nowDate
        },
        getLocalNewDate() {
            const currentTime = this.getCurrentTime();
            if(currentTime) return currentTime;
            return getCurrentTime();
        },
        // 年和季度切换
        async loginSelect () {
            let self = this
            $('.select_option').click(function(){
                $(this).addClass('select_option_color').siblings().removeClass('select_option_color')
                $('.login_content').hide()
                $('.login_content').eq($(this).index()).show()
                if ($(this).index() === 0) {
                    self.disabledSelect2 = true
                    self.disabledSelect1 = false
                } else {
                    self.disabledSelect2 = false
                    self.disabledSelect1 = true
                }
            })
        },
        // 切换年份获取对应年份数据
        async geographySort(lable){
            document.getElementById('sort_name').innerHTML = lable
            const newDate = this.getLocalNewDate().split('/')[0] - 2
            this.selectVal(`${newDate}年`)
        },
        async selectVal(label){
            $('.u_animation1').fadeOut(700)
            $('.u_animation1').fadeIn(700)
            $('#leida_01').attr('style','display:block')
            $('#leida_02').attr('style','display:none')
            const rLoading = this.openLoading()
            let self = this
            let startTime = ''
            let endTime = ''
            if (label.includes('年')){
                let yearName = label.split('年')[0]
                startTime = `${JSON.parse(yearName)}-01-01 00:00:00`
                endTime = `${JSON.parse(yearName) + 1}-01-01 00:00:00`
            } else if (label[0].includes('季度')){
                let jiduName = label[0].split(' ')[0]
                startTime = `${jiduName}-${label[1].split(' ')[0]}-01 00:00:00`
                endTime = `${jiduName}-${label[1].split(' ')[1]}-01 00:00:00`
            }
            // 由北到南地理排序
            const res = await axios.get('/bridgetunnel/score/time', {
                    params: {
                        startTime: startTime,
                        endTime: endTime
                    },
                })
                let getSuidaoData = res.data

                self.yearSelectData = []
                self.yearSelectData = res.data
                self.suidaoList = []
                let suidaoListArr = new Array()
                let data1 = new Array()
                let sortName = document.getElementById('sort_name').innerHTML
                if (sortName === '由北到南地理排序') {
                    getSuidaoData.forEach((element, index) => {
                        self.suidaoList.push({
                            index: index + 1,
                            TunnelId: element.tunnelId,
                            name: element.tunnelName,
                            number: element.technicalScore,
                            length: element.length[0].value,
                            time: element.openingTime[0].split('T')[0]
                        })
                        suidaoListArr.push({
                            TunnelId: element.tunnelId,
                            name: element.tunnelName,
                            number: element.technicalScore,
                            length: element.length[0].value,
                            time: element.openingTime[0].split('T')[0]
                        })
                    })
                } else if (sortName === '由南到北地理排序'){
                    let indexs = 0
                    for (let i = getSuidaoData.length - 1; i >= 0; i--) {
                        indexs = indexs + 1
                        self.suidaoList.push({
                            index: indexs,
                            TunnelId: getSuidaoData[i].tunnelId,
                            name: getSuidaoData[i].tunnelName,
                            number: getSuidaoData[i].technicalScore,
                            length: getSuidaoData[i].length[0].value,
                            time: getSuidaoData[i].openingTime[0].split('T')[0]
                        })
                        suidaoListArr.push({
                            TunnelId: getSuidaoData[i].tunnelId,
                            name: getSuidaoData[i].tunnelName,
                            number: getSuidaoData[i].technicalScore,
                            length: getSuidaoData[i].length[0].value,
                            time: getSuidaoData[i].openingTime[0].split('T')[0]
                        })
                    }
                }
                rLoading.close()
                // 条形图根据评分字段从大到小排序
                suidaoListArr.sort(function(a,b){
                    return b.number < a.number ? -1: 1
                })
                self.newsuidaoList = []
                suidaoListArr.forEach((element, index) => {
                    self.newsuidaoList.push({
                        index: index + 1,
                        TunnelId: element.TunnelId,
                        name: element.name,
                        number: element.number,
                        length: element.length,
                        time: element.time
                    })
                    data1.push(element.number)
                })
                data1.sort(function(a,b){
                    return b < a ? -1: 1
                })
            await self.$nextTick()
            // 排名 && 桥隧名称 - 条形图
            let zhuColor = ['#0079c4','#067ac2', '#0d7dc2', '#1683c7', '#1b85c7', '#2285c2', '#2888c4', '#2f89c2', '#358cc2', '#3b8dc0', '#4392c4', '#4994c2', '#5096c2', '#599bc4', '#5f9cc2', '#669fc2', '#6da3c4', '#72a4c4', '#79a7c4', '#82adc7']
            for (let i = 0; i < data1.length; i++) {
                let myCharts1 = echarts.init(document.getElementById(`myChart${i}`))
                let options1 = {
                    color: zhuColor[i],
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: '1%',
                        right: '0'
                    },
                    xAxis: {
                        type: 'value',
                        min: 40,
                        max: 101,
                        splitLine: {
                            show: false 
                        }
                    },
                    yAxis: {
                        type: 'category',
                        data: ''
                    },
                    series: [{
                        type: 'bar',
                        data: [data1[i]],
                        label:{
                            normal:{
                                show: true,
                                position: 'insideLeft',
                                offset: [20, 6],
                                textStyle:{
                                    color: '#000',
                                    fontSize: 16,
                                    fontWeight: 600
                                },
                                formatter: function(params){
                                    return '· ' + params.value
                                }
                            }
                        },
                    }]
                };
                myCharts1.setOption(options1)
                window.addEventListener('resize', function () {
                    myCharts1.resize()
                });
            }
            // 排名 && 桥隧名称 - 雷达图
            let zhuColor1 = ['#C9E3EE','#67BFE2', '#EBC6C3', '#DC6050', '#C3CAD5', '#DFB417', '#EFE0B2', '#5B6E91', '#C3E8DB', '#4169E1', '#00FF00', '#FFA500', '#CD5C5C', '#008B8B', '#00FA9A', '#808000', '#00BFFF', '#CD853F', '#9ACD32', '#98FB98']
            
            getSuidaoData.sort(function(a,b){
                return b.technicalScore < a.technicalScore ? -1: 1
            })
            for (let i = 0; i < getSuidaoData.length; i++) {
                let data2 = new Array()
                data2.push(`${getSuidaoData[i].ventilationScore}`, `${getSuidaoData[i].lightingScore}`, `${getSuidaoData[i].waterSupplyDrainageScore}`, `${getSuidaoData[i].weakCurrentScore}`, `${getSuidaoData[i].powerSupplyScore}`, `${getSuidaoData[i].fireFightingScore}`)
                let myCharts2 = echarts.init(document.getElementById(`myChart2${i}`))
                let options2 = {
                    color: zhuColor1[i],
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis',
                        position: ['50%', '50%']
                    },
                    legend: {
                        left: 'center',
                        data: []
                    },
                    radar: [{
                        indicator: [
                            {text: '通风设施', min: 70, max: 100},
                            {text: '照明设施', min: 70, max: 100},
                            {text: '给排水设施', min: 70, max: 100},
                            {text: '弱电设施', min: 70, max: 100},
                            {text: '供配电设施', min: 70, max: 100},
                            {text: '消防设施', min: 70, max: 100}
                        ],
                        center: ['51%', '53%'],
                        radius: 60,
                        name: {
                            textStyle: {
                                padding: [-5, -5]
                            }
                        }
                    }],
                    series: [{
                        type: 'radar',
                        tooltip: {
                            trigger: 'item'
                        },
                        areaStyle: {},
                        data: [{
                            value: data2,
                            name: getSuidaoData[i].tunnelName
                        }]
                    }]
                };
                myCharts2.setOption(options2)
                window.addEventListener('resize', function () {
                    myCharts2.resize()
                });
            }
        },
        // 点击单个隧道名称获取单个隧道的平均值
        async clickqiaosuiName(TunnelId, name){
            this.yearSelectData.forEach(ele => {
                if (ele.tunnelId === TunnelId) {
                    $('#leida_01').attr('style','display:none')
                    $('#leida_02').attr('style','display:block')
                    let data3 = new Array()
                    data3.push(`${ele.meanVentilationScore}`, `${ele.meanLightingScore}`, `${ele.meanWaterSupplyDrainageScore}`, `${ele.meanWeakCurrentScore}`, `${ele.meanPowerSupplyScore}`, `${ele.meanFireFightingScore}`)
                    let myCharts3 = echarts.init(document.getElementById('singleLeidaEcharts'))
                    let options3 = {
                        color: '#FFA500',
                        title: {
                            text: ''
                        },
                        tooltip: {
                            trigger: 'axis',
                            position: ['50%', '50%']
                        },
                        legend: {
                            data: [ele.tunnelName],
                            bottom: "10%",
                            textStyle: {
                                color: "#fff"
                            },
                        },
                        radar: [{
                            indicator: [
                                {text: '通风设施', min: 70, max: 100},
                                {text: '照明设施', min: 70, max: 100},
                                {text: '给排水设施', min: 70, max: 100},
                                {text: '弱电设施', min: 70, max: 100},
                                {text: '供配电设施', min: 70, max: 100},
                                {text: '消防设施', min: 70, max: 100}
                            ],
                            center: ['51%', '45%'],
                            radius: 150,
                            name: {
                                textStyle: {
                                    padding: [-5, -5]
                                }
                            }
                        }],
                        series: [{
                            type: 'radar',
                            tooltip: {
                                trigger: 'item'
                            },
                            areaStyle: {},
                            data: [{
                                value: data3,
                                name: ele.tunnelName
                            }]
                        }]
                    };
                    myCharts3.setOption(options3)
                    window.addEventListener('resize', function () {
                        myCharts3.resize()
                    });
                }
            })
            this.dialogVisible = true
            this.dialogTitle = name
            this.dialogTunnelId = TunnelId
            this.dialogRadioVal('1')
            this.dialogRadio = '1'
        },
        // 隧道 - 设施的完好率
        async dialogRadioVal(number){
            const rLoading = this.openLoading()
            const res = await axios.get(`/bridgetunnel/tunnel/${this.dialogTunnelId}/score/type`, {
                    params: {
                        scoreType: number
                    },
                })
            let dialogxAxis = new Array()
            let dialogSeries = new Array()
            res.data.scores.forEach(ele => {
                dialogxAxis.push(ele.time.split('T')[0])
                dialogSeries.push(ele.value)
            })
            let dialogChart = echarts.init(document.getElementById(`dialogChart`))
            let options03 = {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: '',
                    bottom: "3%"
                },
                grid: {
                    left: "2%",
                    right: "2%",
                    top: "10%"
                },
                xAxis: {
                    type: 'category',
                    data: dialogxAxis
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    name: this.dialogTitle,
                    type: 'line',
                    smooth: true,
                    data: dialogSeries
                }]
            };
            dialogChart.setOption(options03)
            window.addEventListener('resize', function () {
                dialogChart.resize()
            })
            rLoading.close()
        },
        // 点击单个隧道名称获取单个隧道的平均值 - 返回总体雷达图
        async backLeida () {
            $('#leida_01').attr('style','display:block')
            $('#leida_02').attr('style','display:none')
        },
        // 年化技术评分
        async radioVal(val){
            $('.u_animation2').fadeOut(400)
            $('.u_animation2').fadeIn(400)
            const rLoading = this.openLoading()
            let chartTitle = [{lable:'1',name:'年化技术评分'},{lable:'2',name:'通风设施'},{lable:'3',name:'照明设施'},{lable:'4',name:'给排水设施'},{lable:'5',name:'弱电设施'},{lable:'6',name:'供配电设施'},{lable:'7',name:'消防设施'},{lable:'8',name:'服务评分'}]
            chartTitle.forEach(element => {
                 if (val === element.lable){
                     this.valTitle = element.name
                     return
                 }
            })
            const res = await axios.get(`/bridgetunnel/score/type`, {
                    params: {
                        scoreType: val
                    },
                })
                this.indexSpiralData = res.data
            this.getIndexYearVal(this.options[0].value)
            rLoading.close()
        },
        // 年化技术评分 => 根据年份查询数据
        async getIndexYearVal(vals){
            const rLoading = this.openLoading()
            let elementScores = new Array()
            this.indexSpiralData.forEach((element, index) => {
                if (element.scores === null){
                    elementScores.push({
                        name: element.tunnelName,
                        value: 0
                    })
                } else {
                    element.scores.forEach(ele => {
                        if (ele.time.split('T')[0].split('-')[0] === vals.split('年')[0]){
                            elementScores.push({
                                name: element.tunnelName,
                                value: ele.value - 70
                            })
                        }
                    })
                }
            })
            elementScores.sort(function(a,b){
                return b.value < a.value ? -1: 1
            })
            let elementScoresName = new Array()
            for (let i = elementScores.length-1; i >= 0; i--) {
                elementScoresName.push(elementScores[i].name)
            }
            let myCharts3 = echarts.init(document.getElementById(`myChartLine`))
            let options3 = {
                title: {
                    text: this.valTitle,
                    textStyle: {
                        color: "#fff"
                    },
                    left: 'center'
                },
                legend: {
                    data: elementScoresName,
                    top: "bottom",
                    textStyle: {
                        color: "#fff"
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: (params) => {
                        return `${params.value + 70}`
                    }
                },
                series: [{
                    name: '',
                    type: 'pie',
                    radius: [40, 220],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    itemStyle: {
                        borderRadius: 8
                    },
                    label: {
                        show: true,
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    data: elementScores
                }]
            };
            myCharts3.setOption(options3)
            window.addEventListener('resize', function () {
                myCharts3.resize()
            });
            rLoading.close()
        },
        // 进入隧道项目
        enterSuidaoProject(TunnelId,number,name) {
            this.$router.push('/bridgeSurvey')
            localStorage.setItem('TunnelId', TunnelId)
            localStorage.setItem('suidaonumber', number)
            localStorage.setItem('suidaoName', name)
        },
        // 桥隧管理
        qiaosuiManager(){
            this.$router.push('/bridgeSurvey')
            localStorage.setItem('TunnelId', this.suidaoList[0].TunnelId)
            localStorage.setItem('suidaonumber', this.suidaoList[0].number)
            localStorage.setItem('suidaoName', this.suidaoList[0].name)
        },
        // 返回项目列表
        backSuidaoIndex: function () {
            this.$router.push(`/bridgeTunnelIndex`)
        }
    }
}
</script>